import { useEffect, useState } from 'react'
import { ChecklistPhase, StatusData } from '@oneethos/shared'
import { LoanApplicationPhase } from './loan-application-phase'
import { LoanFundingPhase } from './loan-funding-phase'
import { Comment } from './comment'

type ChecklistItemsProps = {
  project: StatusData
  onChange: (project: StatusData) => void
  id?: string
}

type PhaseTabProps = {
  label: string
  isSelected: boolean
  onClick: () => void
  className?: string
}

const PhaseTab = ({ label, isSelected, onClick, className }: PhaseTabProps) => {
  const finalClassName = `
    border text-center py-3 flex-grow-1 pointer
    ${isSelected ? 'bg-primary-subtle border-primary-subtle' : ''}
    ${className || ''}
  `
  return (
    <div onClick={onClick} className={finalClassName}>
      {label}
    </div>
  )
}

export const ChecklistItems = ({
  project,
  onChange,
  id,
}: ChecklistItemsProps) => {
  const isPrequalified = project.isPrequalified === 'yes'
  const isProjectClosed = project.isClosed
  const activePhase = project.nTPGiven
    ? ChecklistPhase.LoanFunding
    : ChecklistPhase.LoanApplication
  const [selectedPhase, setSelectedPhase] = useState(activePhase)

  useEffect(() => {
    setSelectedPhase(activePhase)
  }, [activePhase])

  return (
    <div
      aria-disabled={!isPrequalified && isProjectClosed}
      {...((!isPrequalified && isProjectClosed) ? { inert: '' } : {})}
      className={(!isPrequalified && isProjectClosed) ? 'gray-out' : ''}
      id={id}
    >
      <div className='d-flex w-100 my-3'>
        <PhaseTab
          label="1 - Loan Application"
          isSelected={selectedPhase === ChecklistPhase.LoanApplication}
          onClick={() => setSelectedPhase(ChecklistPhase.LoanApplication)}
          className="rounded-start-2"
        />
        <PhaseTab
          label="2 - Loan Funding"
          isSelected={selectedPhase === ChecklistPhase.LoanFunding}
          onClick={() => setSelectedPhase(ChecklistPhase.LoanFunding)}
          className="rounded-end-2"
        />
      </div>
      {project.notesVisibleToInstallers ? <div className='mb-3'>
        <Comment text={project.notesVisibleToInstallers} />
      </div> : null}
      {selectedPhase === ChecklistPhase.LoanApplication && (
        <LoanApplicationPhase
          project={project}
          onChange={onChange}
          disabled={activePhase !== ChecklistPhase.LoanApplication}
        />
      )}
      {selectedPhase === ChecklistPhase.LoanFunding && (
        <LoanFundingPhase
          project={project}
          onProjectChange={onChange}
          disabled={activePhase !== ChecklistPhase.LoanFunding}
        />
      )}
    </div>
  )
}

export default ChecklistItems
